<template>
  <button
    class="group border-bdr-subtle bg-bgr-primary hover:bg-bgr-secondary flex w-full items-center gap-4 rounded-lg border px-4 text-left hover:border-1"
    :class="subtitle ? 'py-2' : 'py-3'"
    type="button"
  >
    <div v-if="icon">
      <Icon :src="icon" />
    </div>
    <div class="flex w-full flex-col overflow-hidden">
      <p class="text-body-default-m truncate">
        {{ title }}
      </p>
      <p v-if="alias !== title" class="text-body-default truncate">
        {{ alias }}
      </p>
      <p v-if="subtitle" class="text-body-default">
        {{ subtitle }}
      </p>
    </div>
    <div class="ml-auto">
      <Icon src="arrow_right" />
    </div>
  </button>
</template>

<script setup lang="ts">
  defineProps<{
    title: string;
    subtitle?: string;
    alias?: string;
    icon?: string;
  }>();
</script>
